<template>
  <div class="search-message-list-container">
    <div v-if="hasMessages > 0" class="messages-count">
      <span>Search results:</span>
      <div class="navigation-controls">
        <GreyArrowUpIcon24
          class="navigation-arrow"
          :class="{ 'disabled': currentMessageIndex === 0 }"
          @click="navigateToPreviousMessage"
        />
        <span class="message-counter">{{ currentMessagePosition }} of {{ hasMessages }}</span>
        <GreyArrowDownIcon24
          class="navigation-arrow"
          :class="{ 'disabled': currentMessageIndex === hasMessages - 1 }"
          @click="navigateToNextMessage"
        />
      </div>
    </div>
    <ul v-if="hasMessages > 0" class="profile-nav client">
      <li
        v-for="(item, index) in clientsArray"
        :id="`case_message_${item.clientId}_${index}`"
        :key="`${item}_${index}`"
        :class="{'active': false}"
      >
        <div v-if="item.chatRooms[0]">
          <div class="client-contacts-wrap">
            <div class="img-item">
              <img
                v-if="item.avatar"
                :src="item.avatar"
                alt="avatar"
              >
              <img
                v-else
                src="https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png"
                alt=""
              >
            </div>
            <a v-if="item.fullName && item.fullName.trim().length > 0">{{ item.fullName.trim() }}</a>
            <a v-else>{{ item.email }}</a>
          </div>
          <ul class="profile-nav device">
            <li
              v-for="(device, i) in item.chatRooms"
              :id="`case_message_${device}_${i}`"
              :key="`${device}_${i}`"
            >
              <ul class="profile-nav chat">
                <li
                  v-for="(chat, indx) in device.lastMessageChatInfo"
                  :id="`case_message_${chat}_${indx}`"
                  :key="`${chat}_${indx}`"
                  :class="{'active': chat.messageId === chosenMessageId}"
                  @click.stop="setTab(chat)"
                >
                  <a>
                    <div class="holder-contacts">
                      <div class="contacts-name">
                        <div class="img-item img-item-messagers">
                          <ImgOfMessangers :name-of-messanger="chat.messengerType.toLowerCase()" />
                        </div>
                        <span class="span-name">{{ chat.chatName }}</span>
                      </div>
                      <div class="info-contact">
                        <div class="spans-data">
                          <div class="desc-contact">
                            <p v-if="chat.messageText">{{ messageToShow(chat) }}</p>
                          </div>
                          <div>
                            <span class="span-date">
                              {{ parseDate(chat.messageDate) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div v-else class="no-messages">
      No messages found
    </div>
  </div>
</template>

<script>
import ImgOfMessangers from './ImgOfMessangers';
import debounce from '@/mixins/debounce';
import {mapActions, mapGetters} from 'vuex';
import parseDate from '@/mixins/parseDate';
import GreyArrowUpIcon24 from '@/components/icons/GreyArrowUpIcon24';
import GreyArrowDownIcon24 from '@/components/icons/GreyArrowDownIcon24';

export default {
  name: 'SearchMessageList',
  components: {
    ImgOfMessangers,
    GreyArrowUpIcon24,
    GreyArrowDownIcon24
  },
  mixins: [debounce, parseDate],
  props: {
    clientsArray: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chosenMessageId: null,
      currentMessageIndex: 0,
    };
  },
  computed: {
    ...mapGetters('messagesTagging', {
      chatData: 'getChatData',
    }),
    allMessages() {
      return this.clientsArray
        .flatMap(client => client.chatRooms)
        .flatMap(chatRoom => chatRoom.lastMessageChatInfo);
    },
    hasMessages() {
      return this.allMessages.length;
    },
    currentMessagePosition() {
      return this.hasMessages > 0 ? this.currentMessageIndex + 1 : 0;
    },
  },
  watch: {
    clientsArray: {
      handler(newVal) {
        if (newVal && newVal.length > 0 && this.allMessages.length > 0) {
          this.currentMessageIndex = 0;
          this.setTab(this.allMessages[0]);
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.clearSearchMessageId();
  },
  methods: {
    ...mapActions('messagesTagging', {
      setChatData: 'setChatData',
      setSearchMessageId: 'setSearchMessageId',
      clearSearchMessageId: 'clearSearchMessageId',
    }),
    setTab(data) {
      let messageId;
      const newChatId = Number(data.chatId);
      const isSameChat = this.chatData && this.chatData.chatId === newChatId;

      this.setChatData({...this.chatData, chatId: newChatId});

      messageId = data.messageId || data.id;
      if (messageId) {
        this.chosenMessageId = messageId;

        this.setSearchMessageId(messageId);

        const messageIndex = this.allMessages.findIndex(msg => msg.messageId === messageId);
        if (messageIndex !== -1) {
          this.currentMessageIndex = messageIndex;
        }
        if (!isSameChat) {
          this.$emit('messageClicked', {messageId, chatId: data.chatId});
        } else {
          this.$emit('messageClicked', {messageId, chatId: data.chatId, isSameChat: true});
        }
      }
    },
    navigateToPreviousMessage() {
      if (this.hasMessages > 0 && this.currentMessageIndex > 0) {
        this.currentMessageIndex--;
        const message = this.allMessages[this.currentMessageIndex];
        this.setTab(message);
      }
    },
    navigateToNextMessage() {
      if (this.hasMessages > 0 && this.currentMessageIndex < this.hasMessages - 1) {
        this.currentMessageIndex++;
        const message = this.allMessages[this.currentMessageIndex];
        this.setTab(message);
      }
    },
    messageToShow(item) {
      if (item.editedMessageText && item.editedMessageText !== item.messageText) return item.editedMessageText;
      return item.messageText || 'No messages preview available';
    },
  },
};
</script>

<style scoped>
.profile-nav.client {
  max-height: 70vh;
}

.profile-nav {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin-top: 0;
  height: calc(700px + 130px);
}

.profile-nav.device, .profile-nav.chat {
  height: fit-content;
}

.profile-nav li {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
  overflow-x: hidden;
}

.profile-nav li a {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  text-decoration: none;
  padding: 16px;
}

.profile-nav.chat > li:hover {
  color: var(--secondary-black-color);
  background-color: var(--gray-bg-color);
}

.profile-nav.chat li.active {
  color: var(--secondary-black-color);
  background-color: var(--light-green);
}

.client-contacts-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.profile-nav .client-contacts-wrap {
  padding: 16px;
}

.profile-nav .client-contacts-wrap a {
  padding: 0;
}

.contacts-name {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.img-item {
  max-width: 32px;
  max-height: 32px;
  overflow: hidden;
  border: 1px solid var(--white-color);
  border-radius: 50%;
}

.img-item img {
  width: 100%;
  height: 100%;
}

.holder-contacts {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.spans-data {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.span-name {
  font-size: 14px;
  font-weight: 700;
  width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.img-item {
  margin-right: 8px;
}

.span-date {
  font-size: 11px;
  font-weight: 500;
  color: var(--secondary-text-color);
}

.info-contact {
  width: 100%;
  display: flex;
  align-items: center;
}

.desc-contact p {
  font-size: 11px;
  font-weight: 500;
  color: var(--light-gray);
  line-height: 160%;
  margin: 0;
  width: 100%;
  max-height: 90px;
  overflow-y: auto;
}

.img-item-messagers {
  width: 30px;
  height: 30px;
  overflow: visible;
}

.no-messages {
  text-align: center;
  padding: 50px 10px;
  color: var(--light-gray);
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
}

.messages-count {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 33px 16px 0;
  font-weight: 500;
  font-size: 14px;
  color: var(--light-gray);
}

.navigation-controls {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.navigation-arrow {
  cursor: pointer;
  margin: 0 8px;
}

.navigation-arrow.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.message-counter {
  font-size: 12px;
  color: var(--secondary-text-color);
  margin: 0 8px;
}

</style>
